<template>
  <v-app>
    <v-app-bar app>
      <v-img
        src="./assets/kampoeng_radja_logo.png"
        v-if="$vuetify.breakpoint.smAndUp"
        max-width="100"
      >
      </v-img>
      <v-toolbar-title class="headline text-uppercase ml-3">
        <span class="font-weight-light">POS Admin Panel</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          color="white"
          depressed
          :to="entrancePackagePath"
          v-if="menuPaketBermainPermitted"
        >
          Paket Bermain
        </v-btn>
        <v-menu open-on-hover offset-y v-if="menuWahanaPermitted">
          <template v-slot:activator="{ on }">
            <v-btn
              color="white"
              :to="attractionPath"
              v-on="on"
              depressed
              v-if="menuWahanaPermitted"
            >
              Wahana
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              :to="attractionSpecialPricePath"
              v-if="menuWahanaPermitted"
            >
              <v-list-item-title>Harga Spesial</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          color="white"
          depressed
          :to="parkingPath"
          v-if="menuParkirPermitted"
        >
          Parkir
        </v-btn>

        <v-menu open-on-hover offset-y v-if="menuOutletPermitted">
          <template v-slot:activator="{ on }">
            <v-btn
              color="white"
              :to="outletPath"
              v-on="on"
              depressed
              v-if="menuOutletPermitted"
            >
              Outlet
            </v-btn>
          </template>
          <v-list>
            <v-list-item :to="outletItemPath" v-if="menuOutletPermitted">
              <v-list-item-title>Barang</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu open-on-hover offset-y v-if="menuMembershipPermitted">
          <template v-slot:activator="{ on }">
            <v-btn
              color="white"
              :to="membershipPath"
              v-on="on"
              depressed
              v-if="menuMembershipPermitted"
            >
              Membership
            </v-btn>
          </template>
          <v-list>
            <v-list-item :to="memberPath" v-if="subMenuDataMemberPermitted">
              <v-list-item-title>Data Member</v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="membershipClassPath"
              v-if="subMenuKelasMembershipOrHakIstimewaPermitted"
            >
              <v-list-item-title>Kelas Membership</v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="membershipPrivilegePath"
              v-if="subMenuKelasMembershipOrHakIstimewaPermitted"
            >
              <v-list-item-title>Hak Istimewa</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu open-on-hover offset-y v-if="menuMasterPermitted">
          <template v-slot:activator="{ on }">
            <v-btn color="white" v-on="on" depressed v-if="menuMasterPermitted">
              Master
            </v-btn>
          </template>
          <v-list>
            <v-list-item :to="terminalPath" v-if="subMenuTerminalPermitted">
              <v-list-item-title>Terminal</v-list-item-title>
            </v-list-item>
            <v-list-item :to="cardPath" v-if="subMenuKartuPermitted">
              <v-list-item-title>Kartu</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu open-on-hover offset-y v-if="menuReportPermitted">
          <template v-slot:activator="{ on }">
            <v-btn color="white" v-on="on" depressed v-if="menuReportPermitted">
              Laporan
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              :to="reportsalesPath"
              v-if="subMenuReportSalesPermitted"
            >
              <v-list-item-title>Penjualan</v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="reportstockPath"
              v-if="subMenuReportStockPermitted"
            >
              <v-list-item-title>Stock Barang</v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="reportmemberPath"
              v-if="subMenuReportMemberPermitted"
            >
              <v-list-item-title>Member</v-list-item-title>
            </v-list-item>
            <v-list-item :to="reportcardPath" v-if="subMenuReportCardPermitted">
              <v-list-item-title>Data Kartu</v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="reporttopupPath"
              v-if="subMenuReportTopupPermitted"
            >
              <v-list-item-title>Top Up Kartu</v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="reportrefundPath"
              v-if="subMenuReportRefundPermitted"
            >
              <v-list-item-title>Refund</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="white" v-on="on" :href="profilePath" depressed>
              Akun
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="logout()">
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      menuName: {
        paketBermain: "PAKET_BERMAIN",
        wahana: "WAHANA",
        parkir: "PARKIR",
        outlet: "OUTLET",
        membership: "MEMBERSHIP",
        master: "MASTER"
      },
      defaultRoles: {
        admin: "ADMIN",
        superadmin: "SUPERADMIN",
        supervisor: "SUPERVISOR",
        operator: "OPERATOR",
        finance: "FINANCE"
      }
    };
  },
  methods: {
    logout() {
      let logoutRedirectUri = process.env.VUE_APP_WEB_UI;
      this.$keycloak.logout({ redirectUri: logoutRedirectUri });
    }
  },
  computed: {
    menuPaketBermainPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin)
      );
    },
    menuWahanaPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin)
      );
    },
    menuParkirPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin)
      );
    },
    menuOutletPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin)
      );
    },
    menuMembershipPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    menuMasterPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor) ||
        roles.includes(this.defaultRoles.finance)
      );
    },
    menuReportPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor) ||
        roles.includes(this.defaultRoles.finance)
      );
    },
    subMenuReportSalesPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    subMenuReportStockPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    subMenuReportMemberPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    subMenuReportCardPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    subMenuReportTopupPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    subMenuReportRefundPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    subMenuDataMemberPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    subMenuKelasMembershipOrHakIstimewaPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin)
      );
    },
    subMenuTerminalPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin) ||
        roles.includes(this.defaultRoles.supervisor)
      );
    },
    subMenuKartuPermitted() {
      let roles = this.$keycloak.realmAccess.roles;
      return (
        roles.includes(this.defaultRoles.admin) ||
        roles.includes(this.defaultRoles.superadmin)
      );
    },
    entrancePackagePath: function() {
      return process.env.VUE_APP_ENTRANCEPACKAGE_PATH;
    },
    attractionPath: function() {
      return process.env.VUE_APP_ATTRACTION_PATH;
    },
    attractionSpecialPricePath: function() {
      return process.env.VUE_APP_ATTRACTION_SPECIALPRICE_PATH;
    },
    memberPath: function() {
      return process.env.VUE_APP_MEMBER_PATH;
    },
    parkingPath: function() {
      return process.env.VUE_APP_PARKING_PATH;
    },
    outletPath: function() {
      return process.env.VUE_APP_OUTLET_PATH;
    },
    outletItemPath: function() {
      return process.env.VUE_APP_OUTLET_ITEM_PATH;
    },
    membershipPath: function() {
      return process.env.VUE_APP_MEMBERSHIP_PATH;
    },
    membershipClassPath: function() {
      return process.env.VUE_APP_MEMBERSHIPCLASS_PATH;
    },
    membershipPrivilegePath: function() {
      return process.env.VUE_APP_MEMBERSHIPPRIVILEGE_UI_PATH;
    },
    terminalPath: function() {
      return process.env.VUE_APP_TERMINAL_PATH;
    },
    reportsalesPath: function() {
      return process.env.VUE_APP_REPORTSALES_PATH;
    },
    reportstockPath: function() {
      return process.env.VUE_APP_REPORTSTOCK_PATH;
    },
    reportmemberPath: function() {
      return process.env.VUE_APP_REPORTMEMBER_PATH;
    },
    reportcardPath: function() {
      return process.env.VUE_APP_REPORTCARD_PATH;
    },
    reporttopupPath: function() {
      return process.env.VUE_APP_REPORTTOPUP_PATH;
    },
    reportrefundPath: function() {
      return process.env.VUE_APP_REPORTREFUND_PATH;
    },
    cardPath: function() {
      return process.env.VUE_APP_CARD_PATH;
    },
    profilePath: function() {
      return process.env.VUE_APP_PROFILE_PATH;
    }
  }
};
</script>
